var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": $t("bw1fvt4", "安全提示"),
      "closable": false,
      "mask-closable": false
    },
    model: {
      value: _vm.showModal,
      callback: function ($$v) {
        _vm.showModal = $$v;
      },
      expression: "showModal"
    }
  }, [_c('Alert', {
    attrs: {
      "show-icon": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function () {
        return [_c('Icon', {
          attrs: {
            "type": "ios-bulb-outline"
          }
        })];
      },
      proxy: true
    }, {
      key: "desc",
      fn: function () {
        var _vm$issuer;
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "flex-direction": "column",
            "gap": "5px"
          }
        }, [_c('span', {
          staticStyle: {
            "text-indent": "32px"
          }
        }, [_vm._v($t("5dm4or2x", "为了进一步提高账户安全性，保护您的个人信息和企业数据，我们已全面启用多因素认证（虚拟MFA）。请您点击“绑定虚拟MFA”，按照页面指引完成绑定操作。如有任何疑问或需要协助，请联系管理员支持。感谢您的理解与配合！"))]), _c('div', {
          staticStyle: {
            "display": "flex",
            "justify-content": "space-between"
          }
        }, [_c('span', {
          staticStyle: {
            "text-indent": "32px"
          }
        }, [_vm._v(_vm._s(`${_vm.unitName}`))])]), _c('div', {
          staticStyle: {
            "display": "flex",
            "justify-content": "space-between"
          }
        }, [_c('span', [_vm._v(_vm._s(`${(_vm$issuer = _vm.issuer) === null || _vm$issuer === void 0 ? void 0 : _vm$issuer.issuer}（${_vm.unitCode}）`))])])])];
      },
      proxy: true
    }])
  }, [_vm._v(` ${$t("a1v0c76", "尊敬的用户：")} `)]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v($t("q2w9b66", "返回单位选择"))]), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v($t("ri4l967", "绑定虚拟MFA"))])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };